import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import TextEditor from '../../../../../../shared/components/TextEditor';
import { setDescription } from '../../../../../../store/influencer/offerInfluencerSlice';
import { IAllStates } from '../../../../../../store/rootReducer';
import DOMPurify from 'dompurify';
import FilePlaceholder from '../../../../../../shared/components/placeholder/FilePlaceholder';
import { Fancybox } from '../../../../../../shared/components/Fancybox';
import { Col } from 'react-bootstrap';

export function ContentTab() {
    const { campaign, initialOffer, requiredFieldChangeColor } = useSelector(
        (state: IAllStates) => state.offerInfluencer
    );
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const changeTextFieldHandler = (value: string) => {
        // const editorValue = value.replace(/<[^\/>][^>]*><\/[^>]+>/g, '');
        dispatch(setDescription(value));
    };
    return (
        <div>
            <div className="mb-2">
                <h6 className="text-muted">{t('influencer.offer_management.modal.content_briefing')}</h6>
                <p>{t('influencer.offer_management.modal.content_briefing_description')}</p>
                {campaign?.offers[0]?.description ? (
                    <div
                        className="remove-html-styling"
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(campaign?.offers[0]?.description ?? '-'),
                        }}
                    />
                ) : (
                    <TextEditor
                        classes={'text-editor-height'}
                        state={initialOffer.description}
                        placeholder={t('influencer.offer_management.modal.content_briefing_placeholder')}
                        hasError={requiredFieldChangeColor}
                        changeTextFieldHandler={value => changeTextFieldHandler(value)}
                    />
                )}
            </div>
            <div className="mt-1 mt-md-4">
                <h6 className="text-muted">{t('influencer.offer_management.modal.campaign_description')}</h6>
                <div
                    className="mb-2 remove-html-styling"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(campaign?.adDescription ?? '-') }}
                />
            </div>
            <div>
                <h6 className="text-muted">{t('influencer.offer_management.modal.relevant_hash')}</h6>
                <div className="d-flex flex-wrap">
                    <p>{campaign?.hashtags ?? '-'}</p>
                </div>
            </div>
            <div>
                <h6 className="text-muted">{t('influencer.offer_management.modal.tagging')}</h6>
                <div className="d-flex flex-wrap">
                    <p>{campaign?.profileTags ?? '-'}</p>
                </div>
            </div>
            <div className="mb-2">
                <h6 className="text-muted">{t('influencer.offer_management.modal.additional_briefing_files')}</h6>

                <Fancybox>
                    <div className="row">
                        {!!campaign?.campaignImages?.filter(image => image?.purpose === 'style_mood_image')?.length
                            ? campaign?.campaignImages
                                  ?.filter(image => image?.purpose === 'style_mood_image')
                                  ?.map(moonBoard => {
                                      return (
                                          <div className="my-2 col-md-3" key={moonBoard?.id}>
                                              <FilePlaceholder
                                                  file={moonBoard}
                                                  styleContent={{ height: 130 }}
                                                  classIcon="font-120"
                                              />
                                          </div>
                                      );
                                  })
                            : '-'}
                    </div>
                </Fancybox>
            </div>
            <div className="mb-2">
                <h6 className="text-muted">{t('influencer.offer_management.modal.inspiration_links')}</h6>
                <a href={campaign?.url} target="_blank" rel="noreferrer">
                    {campaign?.url ?? '-'}
                </a>
            </div>
        </div>
    );
}
